import React, { FC } from 'react';

import SignUpEmailForm from 'components/auth/SignUpEmailForm';
import terms from 'i18n';
import TemplateAuthPage from 'pages/TemplateAuthPage';

const SignUpEmailPage: FC = () => (
  <TemplateAuthPage>
    <SignUpEmailForm title={terms.REGISTRATION} />
  </TemplateAuthPage>
);

export default SignUpEmailPage;
